// packages import
import { Box } from "@mui/material";
import { Reducer, useContext, useEffect, useReducer, useState } from "react";
import { useParams } from "react-router-dom";
// component import
import { CardBox } from "../../theme/styleComponents";
import { Alert } from "../common/Alert";
import { ContentHead } from "../common/ContentHead";
import { EmptyData } from "../common/EmptyData";
import { AddNewCaseType } from "./AddNewCaseType";
import { CaseTypeListing } from "./CaseTypeListing";
import { DeleteCaseType } from "./DeleteCaseType";
import { ViewCurrentCaseType } from "./ViewCurrentCaseType";
//other
import { CaseTypesPayload, useFetchLawTypeLazyQuery } from "../../../generated";
import { GRAPHQL_QUERY_POLICY } from "../../constants";
import { AuthContext } from "../../context";
import { flexCenter } from "../../theme/styleConstants";
import { titleize } from "../../utils";
import { LawTypeAction, LawTypeState, lawTypeInitialState, lawTypeReducer } from "./LawTypeReducer";

export const LawTypeDetail = () => {
  const [lawType, setLawType] = useState<string | undefined | null>("")
  const [caseTypes, setCaseTypes] = useState<CaseTypesPayload['caseTypes']>()
  const { isAdmin } = useContext(AuthContext)
  const { id: lawTypeId } = useParams()
  const [lawTypeState, lawTypeDispatch] = useReducer<Reducer<LawTypeState, LawTypeAction>>(lawTypeReducer, lawTypeInitialState)

  const [fetchLawTypes, { loading, refetch }] = useFetchLawTypeLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,

    onError() {
      Alert.error("Case types not fetched, something went wrong!")
    },

    onCompleted(data) {
      if (data) {
        const { fetchLawType } = data
        const { lawType } = fetchLawType
        const { caseTypes, name } = lawType || {}

        setLawType(name)

        if (caseTypes) {
          const { response } = fetchLawType
          const { status } = response || {}

          if (status === 200) {
            setCaseTypes(caseTypes)
          }
        }
      }
    }
  })

  useEffect(() => {
    if (lawTypeId) {
      fetchLawTypes({
        variables: {
          lawTypeInput: {
            id: lawTypeId,
          }
        }
      })
    }
    // eslint-disable-next-line
  }, [lawTypeId])

  const isEmpty = !loading && caseTypes && caseTypes?.length === 0

  return (
    <Box>
      <CardBox marginTop={3}>
        <ContentHead
          backButton={true}
          buttonText={isAdmin ? 'Create' : ''}
          title={(titleize(lawType || '') + "'s Matter Types") || ""}
        />

        {isEmpty ?
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 255px)' }}>
            <EmptyData title={"No case type found"} />
          </Box>
          :
          <CaseTypeListing loading={loading} caseTypes={caseTypes} dispatch={lawTypeDispatch} />
        }
      </CardBox>

      <AddNewCaseType refetch={refetch} lawTypeId={lawTypeId} />
      <ViewCurrentCaseType state={lawTypeState} dispatch={lawTypeDispatch} refetch={refetch} />
      <DeleteCaseType state={lawTypeState} dispatch={lawTypeDispatch} refetch={refetch} />
    </Box>
  )
}